import Page from 'components/layout/Page';
import BlogCard from 'components/marketingSite/blog/cards/BlogCard';
import BlogCta from 'components/marketingSite/blog/layout/BlogCta';
import BlogPagination from 'components/marketingSite/blog/layout/BlogPagination';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  WP_REST_API_Categories,
  WP_REST_API_Posts,
  WP_REST_API_Tags
} from 'wp-types';
import {
  StyledBlog,
  StyledBlogCards,
  StyledBlogHeader,
  StyledBlogSpotlightCards
} from './BlogComponent.styled';
import BlogSpotlightCard from './cards/BlogSpotlightCard';
import { BlogCategoryFilter } from './categories/BlogCategoryFilter';
import { getPostThumb, sortCategories } from './utils/blogUtils';
import { useMemo } from 'react';

type BlogComponentProps = {
  posts?: WP_REST_API_Posts;
  featuredPosts?: WP_REST_API_Posts;
  categories?: WP_REST_API_Categories;
  totalPosts: number;
  totalPages: number;
  currentPage: number;
  category?: string;
  tags?: WP_REST_API_Tags;
};

const BlogComponent: React.FC<BlogComponentProps> = ({
  posts = [],
  tags = [],
  featuredPosts = [],
  categories = [],
  category,
  totalPosts,
  totalPages,
  currentPage
}) => {
  const { t } = useI18n('blog');

  const sortedCategories = useMemo(
    () => sortCategories(categories),
    [categories]
  );

  return (
    <Page hasScrollTop>
      <StyledBlog>
        <StyledBlogHeader>
          <Heading1>{t('blog.title')}</Heading1>
          <div
            dangerouslySetInnerHTML={{
              __html: t('blog.desc')
            }}
          ></div>
        </StyledBlogHeader>
        <BlogCategoryFilter
          category={category}
          sortedCategories={sortedCategories}
        />
        {featuredPosts?.length > 0 ? (
          <StyledBlogSpotlightCards>
            {featuredPosts.map((post) => (
              <BlogSpotlightCard
                post={post}
                key={post.slug}
                title={post.title.rendered}
                url={post.slug}
                thumb={getPostThumb(post)}
                date={post.date}
                excerpt={post.excerpt.rendered}
                allTags={tags}
              />
            ))}
          </StyledBlogSpotlightCards>
        ) : null}
        <StyledBlogCards>
          {posts?.map((post) => {
            return (
              <BlogCard
                post={post}
                key={post.slug}
                title={post.title.rendered}
                url={post.slug}
                thumb={getPostThumb(post)}
                date={post.date}
                allTags={tags}
              />
            );
          })}
        </StyledBlogCards>
        {totalPages > 1 && (
          <BlogPagination
            totalPosts={totalPosts}
            totalPages={totalPages}
            currentPage={currentPage}
            category={category}
          />
        )}
        <BlogCta />
      </StyledBlog>
    </Page>
  );
};

export default BlogComponent;
